const MtrPlusOutline={
    "name": "mtr-plus",
    "theme": "outline",
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 24 24"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "fill": "currentColor",
                    "d": "M18 13h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5V6a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2z"
                }
            }
        ]
    }
};
export default MtrPlusOutline;